import type { ProductItem } from '../types';

interface Props {
  products: ProductItem[];
  selectedProductId: string | null;
  onSelect: (productId: string) => void;
  required: boolean;
  missing: boolean;
  /** Quando false il prezzo NON viene mostrato (toggle admin "show_price"). */
  showPrice?: boolean;
}

export default function ProductCardList({
  products,
  selectedProductId,
  onSelect,
  required,
  missing,
  showPrice = true,
}: Props) {
  if (!products.length) return null;

  return (
    <div className="aw-product-list">
      <div className="aw-product-list-label">
        {required ? 'Scegli il servizio *' : 'Scegli il servizio (opzionale — clicca di nuovo per deselezionare)'}
      </div>
      <div className="aw-product-grid">
        {products.map((p) => {
          const isSel = selectedProductId === p.id;
          const hasPrice = showPrice && typeof p.price === 'number' && p.price > 0;
          return (
            <button
              key={p.id}
              type="button"
              className={`aw-product-card ${isSel ? 'aw-selected' : ''} ${missing && !isSel ? 'aw-product-card-missing' : ''}`}
              onClick={() => onSelect(isSel ? '' : p.id)}
              aria-pressed={isSel}
            >
              <div className="aw-product-card-head">
                <span className="aw-product-card-name">{p.name}</span>
                {hasPrice && (
                  <span className="aw-product-card-price">€ {(p.price ?? 0).toFixed(2)}</span>
                )}
              </div>
              {p.description && (
                <p className="aw-product-card-desc">{p.description}</p>
              )}
            </button>
          );
        })}
      </div>
      {missing && (
        <p className="aw-product-list-error">
          Devi scegliere un servizio per continuare.
        </p>
      )}
    </div>
  );
}
